(function() {

  // Skip diretto per crawler / bot, se l’helper globale esiste
  if (window.isCrawlerUserAgent && window.isCrawlerUserAgent()) {
    return;
  }

  // ---------------------------------------------------
  // Utility: decodifica eventuali entità HTML (es: &#39;)
  // ---------------------------------------------------
  function decodeHtmlEntities(str) {
    if (!str) return str;
    var txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  // ---------------------------------------------------
  // Festività italiane (fisse + 24/12 + 31/12)
  // ---------------------------------------------------
  function isItalyFixedHoliday(date) {
    var d = date.getDate();
    var m = date.getMonth() + 1;
    var key = (d < 10 ? '0' + d : '' + d) + '/' + (m < 10 ? '0' + m : '' + m);

    var fixed = {
      '01/01': true, // Capodanno
      '06/01': true, // Epifania
      '25/04': true, // Liberazione
      '01/05': true, // Lavoro
      '02/06': true, // Repubblica
      '15/08': true, // Ferragosto
      '01/11': true, // Ognissanti
      '08/12': true, // Immacolata
      '25/12': true, // Natale
      '26/12': true, // Santo Stefano
      '24/12': true, // Vigilia
      '31/12': true  // San Silvestro
    };

    return !!fixed[key];
  }

  // Algoritmo per data di Pasqua (domenica)
  function getEasterSunday(year) {
    var f = Math.floor;
    var G = year % 19;
    var C = f(year / 100);
    var H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
    var I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
    var J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
    var L = I - J;
    var month = 3 + f((L + 40) / 44) - 1; // 0-based
    var day = L + 28 - 31 * f(month / 4);

    return new Date(year, month, day);
  }

  function isEasterMonday(date) {
    var year = date.getFullYear();
    var easterSunday = getEasterSunday(year);
    var easterMonday = new Date(
      easterSunday.getFullYear(),
      easterSunday.getMonth(),
      easterSunday.getDate() + 1
    );
    return (
      date.getFullYear() === easterMonday.getFullYear() &&
      date.getMonth() === easterMonday.getMonth() &&
      date.getDate() === easterMonday.getDate()
    );
  }

  function isItalyHoliday(date) {
    return isItalyFixedHoliday(date) || isEasterMonday(date);
  }

  // ---------------------------------------------------
  // Giorni lavorativi: lun–ven, no weekend, no festività
  // ---------------------------------------------------
  function isWorkingDay(date) {
    var day = date.getDay(); // 0 = Sun, 6 = Sat
    if (day === 0 || day === 6) return false;
    if (isItalyHoliday(date)) return false;
    return true;
  }

  // Primo giorno lavorativo valido per evasione:
  // - se ora < cutoff → oggi (se lavorativo)
  // - se ora >= cutoff → primo lavorativo successivo
  function getShipDate(now) {
    var cutoffHour = window.shippingEstimateConfig.settings.shipping_cutoff_hour;
    var cutoffMinute = window.shippingEstimateConfig.settings.shipping_cutoff_minute;

    var today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    var includeToday =
      now.getHours() < cutoffHour ||
      (now.getHours() === cutoffHour && now.getMinutes() < cutoffMinute);

    var d = new Date(today.getTime());
    if (!includeToday) {
      d.setDate(d.getDate() + 1);
    }

    while (!isWorkingDay(d)) {
      d.setDate(d.getDate() + 1);
    }

    return d;
  }

  // Somma N giorni lavorativi, escludendo il giorno di partenza
  function addWorkingDays(startDate, days) {
    var d = new Date(startDate.getTime());
    var added = 0;

    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (isWorkingDay(d)) {
        added++;
      }
    }

    return d;
  }

  // ---------------------------------------------------
  // Locale & formattazioni giorno / ora
  // ---------------------------------------------------
  function sameDay(a, b) {
    return (
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate()
    );
  }

  // Legge la lingua: prima da config, poi da <html lang="...">
  function getLocaleCode() {
    if (window.shippingEstimateConfig && window.shippingEstimateConfig.locale) {
      return ('' + window.shippingEstimateConfig.locale).split('-')[0].toLowerCase();
    }

    var lang = document.documentElement.getAttribute('lang') || '';
    if (!lang) return 'en';

    return lang.split('-')[0].toLowerCase();
  }

  // Usa i nomi dei giorni dal config (Liquid), formato: "lunedì 2" / "Monday 2"
  function formatDateLabel(date, cfg) {
    var weekdays = (cfg && cfg.weekdays) || [];
    var weekdayIndex = date.getDay(); // 0 = Sunday ... 6 = Saturday
    var weekdayName = weekdays[weekdayIndex] || '';
    var day = date.getDate();

    return weekdayName + ' ' + day;
  }

  // Ship day: usa oggi/domani se combacia, altrimenti "lunedì 2" / "Monday 2"
  function getShipDayLabel(shipDate, today, cfg) {
    var strings = cfg.strings;

    if (sameDay(shipDate, today)) {
      return strings.today || 'today';
    }

    var tomorrow = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 1
    );

    if (sameDay(shipDate, tomorrow)) {
      return strings.tomorrow || 'tomorrow';
    }

    return formatDateLabel(shipDate, cfg);
  }

  // Ora di cutoff come stringa, derivata solo da SHIPPING_ESTIMATE_SETTINGS
  function getCutoffTimeString() {
    var localeCode = getLocaleCode();
    var h = window.shippingEstimateConfig.settings.shipping_cutoff_hour;
    var m = window.shippingEstimateConfig.settings.shipping_cutoff_minute;
    var mm = String(m).padStart(2, '0');

    if (localeCode === 'en' && window.shippingEstimateConfig.settings.cutoff_show_meridiem) {
      var meridiem = h >= 12 ? 'PM' : 'AM';
      var hour12 = h % 12;
      if (hour12 === 0) hour12 = 12;
      return hour12 + ':' + mm + ' ' + meridiem;
    }

    // Formato 24h per IT (e tutto il resto)
    var hh = String(h).padStart(2, '0');
    return hh + ':' + mm;
  }

  // ---------------------------------------------------
  // Costruzione messaggio finale (span principale)
  // ---------------------------------------------------
  function buildShippingEstimateMessage() {
    var cfg = window.shippingEstimateConfig;
    if (!cfg || !cfg.strings || !cfg.strings.message) return null;

    var baseTransitDays = window.shippingEstimateConfig.settings.shipping_days || 5;
    var extra = window.shippingEstimateConfig.settings.shipping_extra_days || 0;

    var transitDays = baseTransitDays + extra;

    var now = new Date();
    var today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    var shipDate = getShipDate(now);
    var deliveryDate = addWorkingDays(shipDate, transitDays);

    var timeStr = getCutoffTimeString();
    var shipDayLabel = getShipDayLabel(shipDate, today, cfg);
    var deliveryDayLabel = formatDateLabel(deliveryDate, cfg);

    var template = cfg.strings.message;
    var msg = template
      .replace('%{time}', timeStr)
      .replace('%{ship_day}', shipDayLabel)
      .replace('%{delivery_day}', deliveryDayLabel);

    msg = decodeHtmlEntities(msg);

    return msg;
  }

  // ---------------------------------------------------
  // Costruzione messaggio per il drawer
  // (usa strings.message_drawer, SOLO %{delivery_day})
  // ---------------------------------------------------
  function buildShippingEstimateDrawerMessage() {
    var cfg = window.shippingEstimateConfig;
    if (!cfg || !cfg.strings || !cfg.strings.message_drawer) return null;

    var baseTransitDays = window.shippingEstimateConfig.settings.shipping_days || 5;
    var extra = window.shippingEstimateConfig.settings.shipping_extra_days || 0;

    var transitDays = baseTransitDays + extra;

    var now = new Date();
    var shipDate = getShipDate(now);
    var deliveryDate = addWorkingDays(shipDate, transitDays);

    var deliveryDayLabel = formatDateLabel(deliveryDate, cfg);

    var template = cfg.strings.message_drawer;
    var msg = template.replace('%{delivery_day}', deliveryDayLabel);

    msg = decodeHtmlEntities(msg);

    return msg;
  }

  // ---------------------------------------------------
  // Inizializzazione + ri-render automatico nel drawer
  // ---------------------------------------------------
  var shippingObserverInitialized = false;

  function renderShippingEstimate() {
    var cfg = window.shippingEstimateConfig || {};
    var settings = cfg.settings || {};

    // Ricerco SEMPRE i target nell'HTML corrente
    var target = document.querySelector('[delivery-estimate-target]');
    var drawerTarget = document.querySelector('[delivery-estimate-drawer-target]');

    // Se non c'è nessun target, non faccio nulla
    if (!target && !drawerTarget) return;

    var useDrawerEverywhere = !!settings.force_message_drawer;

    // Messaggio per il drawer
    var drawerMsg = buildShippingEstimateDrawerMessage();

    if (target) {
      var msg = useDrawerEverywhere ? drawerMsg : buildShippingEstimateMessage();
      target.textContent = msg || '';
    }

    if (drawerTarget) {
      drawerTarget.textContent = drawerMsg || '';
    }
  }

  function initShippingEstimate() {
    // Primo render (pagina prodotto, carrello, prima apertura drawer)
    renderShippingEstimate();

    // Observer che intercetta quando il drawer viene ri-renderizzato via AJAX
    if (!shippingObserverInitialized && 'MutationObserver' in window) {
      shippingObserverInitialized = true;

      var observer = new MutationObserver(function(mutationsList) {
        // Osserviamo SIA il drawer che il carrello classico
        var selector = '[delivery-estimate-drawer-target], [delivery-estimate-target]';

        var shouldRerender = Array.prototype.some.call(mutationsList, function(mutation) {
          return Array.prototype.some.call(mutation.addedNodes, function(node) {
            if (node.nodeType !== 1) return false; // non è un elemento

            // Se il nodo stesso è uno dei target
            if (node.matches && node.matches(selector)) return true;

            // O se contiene uno dei target
            if (node.querySelector && node.querySelector(selector)) return true;

            return false;
          });
        });

        if (shouldRerender) {
          renderShippingEstimate();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  // Helper globale se vuoi richiamarlo da console o da altri script
  window.shippingEstimateRefresh = renderShippingEstimate;

  // ---------------------------------------------------
  // Starter semplice (una sola volta) dopo il load
  // ---------------------------------------------------
  var shippingEstimateStarted = false;

  function startShippingEstimate() {
    if (shippingEstimateStarted) return;
    shippingEstimateStarted = true;
    initShippingEstimate();
  }

  // Se il documento è già pronto (script caricato tardi), parte subito
  if (document.readyState === 'complete') {
    startShippingEstimate();
  } else {
    window.addEventListener('load', startShippingEstimate);
  }

})();
